import {register, CloudObject, defineProperty} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class ValidateExcelConfig extends CloudObject {
    /**
     * @return {string}
     */
    getCell() {
        return this.get(ValidateExcelConfig.cellProp);
    }

    /**
     * @return {string}
     */
    getExpectedValue() {
        return this.get(ValidateExcelConfig.expectedValueProp);
    }

    /**
     * @return {string}
     */
    getSheetName() {
        return this.get(ValidateExcelConfig.sheetNameProp);
    }
}

// Hardcoded tags
register('018f05d9bee2144963d8', ValidateExcelConfig);
ValidateExcelConfig.cellProp = defineProperty('018f05d9eb7481b43323');
ValidateExcelConfig.expectedValueProp = defineProperty('018f05dae210ad2d018b');
ValidateExcelConfig.sheetNameProp = defineProperty('018f05dae98682848cef');
